import { ISchemaDefinition, ISchemaProperty } from "../schemas";

function buildPropertyIndex(property: ISchemaProperty): string | null {
    if (property.autoIncrement) {
        return `++${property.key}`;
    }

    if (property.unique) {
        return `$${property.key}`;
    }

    if (property.primary || property.index) {
        return property.key;
    }

    return null;
}

export default function buildSchema(schemaDefinition: ISchemaDefinition): string {
    const primaryPropertyIndex = schemaDefinition.properties.findIndex((property) => property.primary);

    let properties = [...schemaDefinition.properties];

    // Primary key must be first in index declaration to be primary
    if (primaryPropertyIndex >= 0) {
        const primaryProperty = properties.splice(primaryPropertyIndex, 1)[0];
        properties = [primaryProperty].concat(properties);
    }

    const indexes = properties
        .map((property) => buildPropertyIndex(property))
        .filter((propertyString) => !!propertyString);

    // If there is no primary key being configured, add default auto-increment key
    if (primaryPropertyIndex < 0) {
        indexes.unshift("++");
    }

    return indexes.join(",");
}
